<template>
    <div class="workbench-header-wrapper">
        <WorkbenchHeader
            :brand-modules="brandModules"
            :brand-config="brandInfo"
            :menu-list="menuList"
            :active-menu="activeRoute"
            :unread-message-num="unreadMessageNum"
            :current-user="currentUser"
            :show-management-center="showManage"
            :manage-url="adminSiteUrl"
            :show-train-management="showStrain"
            :institution-list="personalInList"
            @brand-click="toHome"
            @workbench-click="toWorkbench"
            @notification-click="toMessageCenter"
            @change-menu="changeMenu"
            @logout="exit"
            @login="login"
        />
    </div>
</template>

<script setup>
import { WorkbenchHeader } from '@yanxiu/header';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { pageJump } from '@/global/location-transfer';
import { getUrl, jumpHref } from '@/router/jumpHref.js';


const props = defineProps({
    brandInfo: {
        type: Object,
        default: () => {
            return {};
        }
    },
    menuList: { // 菜单
        type: Array,
        default: () => {
            return [];
        }
    },
    activeRoute: {
        type: Object,
        default: () => {
            return {};
        }
    },
    unreadMessageNum: {
        type: Number,
        default: 0
    },
    currentUser: {
        type: Object,
        default: () => {
            return {};
        }
    },
    showManage: {
        type: Boolean,
        default: false
    },
    manageUrl: {
        type: String,
        default: ''
    },
    showStrain: {
        type: Boolean,
        default: false
    },
    personalInList: {
        type: Array,
        default: () => []
    }
})
const emits = defineEmits(['change-menu', 'login', 'exit'])

const router = useRouter();
const store = useStore();

const brandModules = computed(() => store.state.brand?.publishBrand?.brandModulesV2 || [])

const adminSiteUrl = computed(() => {
    if (props.manageUrl) {
        return getUrl(props.manageUrl);
    }
    return '/smc/home'
})

/* 页面跳转 */
function navigateToPage(routeName) {
    const route = router.resolve({name: routeName});
    if (route) {
        pageJump(route.path);
    }
}

function toWorkbench() {
    // G_transmit('isDashboardAdmin', {
    //     name: 'isDashboardAdmin',
    // }).then(res => {
    //     if (res.data) {
    //         pageJump(jumpHref.dashboard.admin(), true);
    //     } else {
    navigateToPage('userHomePage');
        // }
    // });
}

function toMessageCenter() {
    navigateToPage('myMessage');
}
function toHome() {
    navigateToPage('home');
}

function changeMenu(menu) {
    emits('change-menu', menu.path);
}

function login() {
    emits('login');
}
function exit() {
    emits('exit');
}
</script>